import React from 'react'

import { Label } from '../../../../../packages/kiti/components/presentation/Text'
import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import EmptyDroppablePanel from '../../../../../components/dnd/EmptyDroppablePanel'
import FieldPanel from './FieldPanel'
import Scroll from '../../../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'

const Wrapper = ({ children }) => (
  <Scroll scrollY maxHeight="75vh" height="100%">
    <Separator paddingV={1} paddingH={4}>
      <Label>Perguntas</Label>
      {children}
    </Separator>
  </Scroll>
)

const FieldsList = () => {
  const form = useForm()
  const fields = form.filter(item => !item.deleted)
  const { addIn } = useFormState()

  if (!fields.length) {
    return (
      <Wrapper>
        <EmptyDroppablePanel type="FIELD" onDrop={({ item }) => addIn([], item)} label="Arraste as perguntas aqui" />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      {fields.map((item, index) => (
        <FieldPanel key={item.reference} index={index} field={item} />
      ))}
    </Wrapper>
  )
}

export default FieldsList
